<style lang="scss" scoped>
.left-menu {
    border-right: 1px solid rgb(240,242,245);
    width: 20% !important;
}
.right-menu {
    margin-left: 50px;
    width: 80%
}
.right-title {
    font-size: 24px;
    color: rgb(24,144,255)
}
.right-content {
    border-left: 5px solid rgb(24,144,255);
    padding-left: 10px;
    margin-bottom: 10px;
}
.right-content-2 {
    padding: 5px 15px;
    background: rgb(240,242,245);
}
.ivu-menu-item-active {
    color: white !important;
    background: #2d8cf0 !important;
}
// .ivu-menu-item-active{
//     color: white;
//     background: #2d8cf0;
// }
</style>
<template>
    <section class="margin-15">
        <div style="display:flex">
            <Menu class="left-menu" :active-name=type @on-select="select">
                <MenuItem :name="1" style="text-align:center">{{$t('fbb.fbatransfer.amazonin', { defaultValue: "移入亚马逊" })}}</MenuItem>
                <MenuItem :name="2" style="text-align:center">{{$t('fbb.fbatransfer.amazonout', { defaultValue: "亚马逊移出" })}}</MenuItem>
            </Menu>
            <div class="right-menu">
                <div v-if="type == 1" style="padding:5px 0;">
                    <header>
                        <span class="right-title">{{$t('fbb.fbatransfer.amazonin', { defaultValue: "移入亚马逊" })}}</span>
                        <span class="margin-left-20">{{$t('fbb.fbatransfer.inprompt', { defaultValue: "是指从仓库调出，发到亚马逊FBA仓" })}}</span>
                    </header>
                    <section class="margin-top-10">
                        <div class="right-content">
                            {{$t('fbb.fbatransfer.standardservice', { defaultValue: "标准服务" })}}
                        </div>
                        <div class="right-content-2" v-html="$t('fbb.fbalist.movetoamazon_standard_service',{defaultValue:'移入亚马逊标准服务'})"></div>
                    </section>
                    <section class="margin-top-10">
                        <div class="right-content">
                            {{$t('fbb.fbatransfer.addedservice', { defaultValue: "增值服务" })}}
                        </div>
                        <div class="right-content-2" v-html="$t('fbb.fbalist.movetoamazon_added_service',{defaultValue:'移入亚马逊增值服务'})"></div>
                    </section>
                </div>
                <div v-else style="padding:5px 0;">
                    <header>
                        <span class="right-title">{{$t('fbb.fbatransfer.amazonout', { defaultValue: "亚马逊移出" })}}</span>
                        <span class="margin-left-20">{{$t('fbb.fbatransfer.outprompt', { defaultValue: "是指从亚马逊FBA仓库调出，发到其他仓库" })}}</span>
                    </header>
                    <section class="margin-top-10">
                        <div class="right-content">
                            {{$t('fbb.fbatransfer.standardservice', { defaultValue: "标准服务" })}}
                        </div>
                        <div class="right-content-2" v-html="$t('fbb.fbalist.amazonout_standard_service',{defaultValue:'亚马逊移出标准服务'})"></div>
                    </section>
                    <section class="margin-top-10">
                        <div class="right-content">
                            {{$t('fbb.fbatransfer.addedservice', { defaultValue: "增值服务" })}}
                        </div>
                        <div class="right-content-2" v-html="$t('fbb.fbalist.amazonout_added_service',{defaultValue:'亚马逊移出增值服务'})"></div>
                    </section>
                </div>
            </div>
        </div>
        <vButtonGroup class="text-right margin-top-30">
            <vButton theme="primary" @click="create">{{$t('global.common.create', { defaultValue: '创建' })}}</vButton>
            <vButton @click="cancel">{{$t("global.common.return", { defaultValue: "返回" })}}</vButton>
        </vButtonGroup>
    </section>
</template>

<script>
export default {
    components: {},
    data() {
        return {
            type: 1,
        };
    },
    computed: {},
    methods: {
        select(name){
            this.type = name
        },
        create() {
            this.$router.push({
                name: this.type == 1 ? "fbaTransferInDetail" : "fbaTransferOutDetail",
                params: { type: "add",},
            });
        },
        cancel() {
            this.$emit("on-close");
        },
    },
};
</script>
